<section class="fiscal-quota" aria-label="Facturación fiscal">
    <h3 class="fiscal-quota__title">Facturación fiscal</h3>

    <div class="fiscal-quota__panel">
        <p class="fiscal-quota__included mb-0" *ngIf="includedQuantity !== null">Tu plan incluye {{ includedQuantity }} facturas al mes.</p>

        <div class="fiscal-quota__field" *ngIf="canEdit; else readOnly">
            <label class="fiscal-quota__label" for="fpp-fiscal-quantity">Cantidad de facturas</label>
            <!-- Sin ngModel (activaría las validaciones del ngForm) y sin [value] en el select: se marcaría antes de que existan las opciones. -->
            <select id="fpp-fiscal-quantity" class="form-select fiscal-quota__select" (change)="onSelect($any($event.target).value)">
                <option *ngFor="let option of options; trackBy: trackOption" [value]="option.quantity" [selected]="option.quantity === value">{{ option.label }}</option>
            </select>
        </div>

        <ng-template #readOnly>
            <p class="fiscal-quota__readonly mb-0" *ngIf="readOnlyQuota && readOnlyQuota.quantity > 0">
                Tienes +{{ readOnlyQuota.quantity }} facturas al mes por {{ readOnlyQuota.monthlyAmountUSD | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}/mes. Puedes cambiar la cantidad al pagar
                tu renovación.
            </p>
        </ng-template>
    </div>
</section>
